import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';

import { history } from '../../../../../helpers';
import { parentSupervisionActions } from '../../../../../store';

function useDeleteSupervision(supervisionId: number | undefined) {
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();
  const [showConfirmDeleteDialog, setShowConfirmDeleteDialog] = useState(false);

  const handleDeleteSupervision = useCallback(async () => {
    if (!supervisionId) return;
    setShowConfirmDeleteDialog(false);

    const { error } = await dispatch(
      parentSupervisionActions.deleteParentSupervision({
        parentSupervisionId: supervisionId,
        getAccessTokenSilently,
      }),
    );

    if (!error) {
      history.navigate('/dashboard');
    }
  }, [dispatch, getAccessTokenSilently, supervisionId]);

  return {
    showConfirmDeleteDialog,
    setShowConfirmDeleteDialog,
    handleDeleteSupervision,
  };
}

export default useDeleteSupervision;
